import templateEmailAddWizardStyles from './templateEmailAddWizardStyles';
import templateWebAddWizardStyles from './templateWebAddWizardStyles';

const transformWizardStyles = (template) => {
  if (template.scope === 'email') {
    return templateEmailAddWizardStyles(template);
  }

  return templateWebAddWizardStyles(template);
};

export default transformWizardStyles;
